module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "completion-text"
  }, [_vm._v(_vm._s(_vm.lang.SET500))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf78ece","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settlement/CheckoutSteps/CompletionMessage.vue
// module id = 416
// module chunks = 1 2